import React, { useState } from 'react';
import { FiClock, FiMail, FiMapPin, FiPhone, FiSend } from 'react-icons/fi';
import './ContactUs.css';

const ContactUs = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

const CONTACT_API_URL =
  process.env.REACT_APP_CONTACT_API_URL ||
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://localhost:5085'
    : 'https://api.sampark-app.com');  // ← Changed to subdomain

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitError('');
    setIsSubmitted(false);

    const form = event.target;
    const formData = new FormData(form);
    const payload = {
      name: formData.get('name')?.toString().trim(),
      email: formData.get('email')?.toString().trim(),
      phone: formData.get('phone')?.toString().trim(),
      subject: formData.get('subject')?.toString().trim(),
      message: formData.get('message')?.toString().trim(),
    };

    console.log('[ContactUs] Submitting to:', `${CONTACT_API_URL}/contact`);
    console.log('[ContactUs] Payload:', payload);

    try {
      setIsSubmitting(true);
      const response = await fetch(`${CONTACT_API_URL}/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      console.log('[ContactUs] Response status:', response.status);

      const data = await response.json().catch(() => ({}));
      console.log('[ContactUs] Response body:', data);

      if (!response.ok) {
        console.error('[ContactUs] Server error:', data);
        throw new Error(data.detail || data.error || 'Request failed');
      }

      console.log('[ContactUs] ✅ Success! Message ID:', data.messageId);
      setIsSubmitted(true);
      form.reset();
      setTimeout(() => setIsSubmitted(false), 3000);
    } catch (error) {
      console.error('[ContactUs] ❌ Fetch failed:', error.message);
      setSubmitError('Unable to send your inquiry right now. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="contact-hero-overlay" aria-hidden="true" />
        <div className="container contact-hero-inner">
          <p className="contact-label">Contact Us</p>
          <h1>Talk to our team about your communication goals</h1>
          <p>
            We help businesses set up reliable SMS, Voice, IVR, WhatsApp, and email workflows.
            Share your requirement and our team will respond with a practical plan.
          </p>
        </div>
      </section>

      <section className="contact-main">
        <div className="container contact-grid">
          <div className="contact-info-panel">
            <h2>Get in touch</h2>
            <p>
              Reach us directly or leave your details in the form. We usually respond within one
              business day.
            </p>

            <ul className="contact-info-list">
              <li>
                <span className="contact-icon"><FiPhone /></span>
                <div>
                  <h3>
                    <a href="tel:+918800418585" aria-label="Call +91 8800418585">
                      Phone
                    </a>
                  </h3>
                  <a href="tel:+918800418585" aria-label="Call +91 8800418585">+91 8800418585</a>
                </div>
              </li>
              <li>
                <span className="contact-icon"><FiMail /></span>
                <div>
                  <h3>Email</h3>
                  <a href="mailto:info@shankarshan.com">info@shankarshan.com</a>
                </div>
              </li>
              <li>
                <span className="contact-icon"><FiMapPin /></span>
                <div>
                  <h3>Office</h3>
                  <p>1/8 Satyen Bose Sarani, Durgapur 713213, West Bengal</p>
                </div>
              </li>
              <li>
                <span className="contact-icon"><FiClock /></span>
                <div>
                  <h3>Working Hours</h3>
                  <p>Mon-Sat, 9:00 AM - 7:00 PM IST</p>
                </div>
              </li>
            </ul>
          </div>

          <div className="contact-form-panel">
            <h2>Send us a message</h2>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-form-row">
                <label htmlFor="contact-name">Full Name</label>
                <input id="contact-name" name="name" type="text" placeholder="Your full name" required />
              </div>
              <div className="contact-form-row two-col">
                <div>
                  <label htmlFor="contact-email">Email</label>
                  <input id="contact-email" name="email" type="email" placeholder="name@company.com" required />
                </div>
                <div>
                  <label htmlFor="contact-phone">Phone</label>
                  <input id="contact-phone" name="phone" type="tel" placeholder="+91" required />
                </div>
              </div>
              <div className="contact-form-row">
                <label htmlFor="contact-subject">Subject</label>
                <input id="contact-subject" name="subject" type="text" placeholder="How can we help?" required />
              </div>
              <div className="contact-form-row">
                <label htmlFor="contact-message">Message</label>
                <textarea
                  id="contact-message"
                  name="message"
                  rows="6"
                  placeholder="Tell us about your requirement"
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary contact-submit-btn"
                disabled={isSubmitting}
              >
                <FiSend />
                {isSubmitting ? 'Sending...' : 'Submit Inquiry'}
              </button>

              {isSubmitted && <p className="contact-form-success">Thank you. Our team will contact you soon.</p>}
              {submitError && <p className="contact-form-success">{submitError}</p>}
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
